export default "__VITE_ASSET__BITggRj0__";